export class SetRegisteringAction {
  public static readonly type = '[Authentication] SetRegisteringAction';
  constructor(public readonly registering: boolean) {}
}
